import { render, staticRenderFns } from "./Pads.vue?vue&type=template&id=0317ec55&"
import script from "./Pads.vue?vue&type=script&lang=js&"
export * from "./Pads.vue?vue&type=script&lang=js&"
import style0 from "./Pads.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports